// extracted by mini-css-extract-plugin
module.exports = {"doctorGreeting":"styles_doctorGreeting__2ByIK"};